module.exports = "\n<router-outlet></router-outlet>\n\n"


//////////////////
// WEBPACK FOOTER
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main